module.exports = __webpack_public_path__ + "static/media/Xtra_Large_7.c888cc28.jpg";